export default __webpack_public_path__ + "static/media/18.8d25b7ce.png";